
import { form5DataInfoType } from '@/types/Information/Form5';
import { Component, Prop, Vue } from 'vue-property-decorator';


@Component
export default class Form5Layout extends Vue {

    @Prop({required:true})
    result!: form5DataInfoType;    
   
}

